import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import Sidebar from "../Common/Sidebar";
import Header from "../Common/Header";
import Footer from "../Common/Footer";

export default function AddVideoGallery() {
  useEffect(() => {
    document.title = "Add Video Gallery | Amin Panel";
  }, []);

  const location = useNavigate();
  var user_name = sessionStorage.getItem("user_name");

  const [youtubelink, setyoutubelink] = useState("");

  const [youtubelinkerror, setyoutubelinkerror] = useState("");

  useEffect(() => {
    if (!user_name) {
      location("/");
    }
  });

  const handleSubmit = (event) => {
    event.preventDefault();
// console.log("youtube_link", youtubelink);
    if (
      youtubelink === ""
    ) {
      if (youtubelink === "") {
        setyoutubelinkerror("Please enter a value");
      } else {
        setyoutubelinkerror("");
      }
    } else {
      const formData = new FormData();

      formData.append("method", "videogallery");
      formData.append("submethod", "insert");
      formData.append("youtube_link", youtubelink);

      const headers = {
        Authorization: `${process.env.REACT_APP_KEY}`,
        "Content-Type": "multipart/form-data",
      };

      // Make API request
      axios
        .post(`${process.env.REACT_APP_BACKEND_LINK}`, formData, { headers })
        .then((response) => {
          // Handle successful response
          console.log(response.data);
          location("/videogallery-list");
        })
        .catch((error) => {
          // Handle error
          console.error(error);
        });
    } 
  };

  return (
    <>
      <div>
        <div className="flex wrapper">
          <Sidebar />

          <div className="page-content">
            <Header />
            <main className="flex-grow p-6">
              <div className="flex justify-between items-center mb-6">
                <h4 className="text-slate-900 dark:text-slate-200 text-lg font-medium">
                  Add Gallery Video
                </h4>
              </div>

              <div className="mt-6">
                <div className="card">
                  <div className="p-6">
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-600 dark:text-gray-200 mb-2">
                        Youtube Link *
                      </label>
                      <input
                        className="form-input"
                        type="text"
                        placeholder="Enter Youtube Link *"
                        onChange={(e) => setyoutubelink(e.target.value)}
                      />                      
                      <span className="text-danger">{youtubelinkerror}</span>
                    </div>
                    <br/>
                    <div className="flex justify-center mb-6">
                      <button
                        className="btn w-full text-white bg-primary"
                        onClick={handleSubmit}
                      >
                        {" "}
                        Save{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </main>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
